import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowLeft, FiHeart, FiCheck, FiX, FiRefreshCw, FiAward, FiInfo } = FiIcons;

const CoupleQuizGame = () => {
  const navigate = useNavigate();
  const [gameState, setGameState] = useState('setup'); // 'setup', 'playing', 'results'
  const [player1Name, setPlayer1Name] = useState('');
  const [player2Name, setPlayer2Name] = useState('');
  const [currentPlayer, setCurrentPlayer] = useState(1);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [score, setScore] = useState({ player1: 0, player2: 0 });
  const [showPrivacy, setShowPrivacy] = useState(false);

  const questions = [
    {
      id: 1,
      question: "Màu sắc yêu thích của đối phương là gì?",
      options: ["Đỏ", "Xanh dương", "Hồng", "Đen", "Trắng", "Vàng"],
      category: "Sở thích cơ bản"
    },
    {
      id: 2,
      question: "Món ăn mà đối phương ghét nhất là gì?",
      options: ["Đồ chua", "Đồ cay", "Hải sản", "Rau xanh", "Đồ ngọt", "Thịt"],
      category: "Ẩm thực"
    },
    {
      id: 3,
      question: "Sở thích trong thời gian rảnh của đối phương?",
      options: ["Xem phim", "Đọc sách", "Chơi game", "Nghe nhạc", "Thể thao", "Nấu ăn"],
      category: "Sở thích"
    },
    {
      id: 4,
      question: "Điều gì khiến đối phương căng thẳng nhất?",
      options: ["Công việc", "Gia đình", "Tiền bạc", "Sức khỏe", "Tương lai", "Mối quan hệ"],
      category: "Tâm lý"
    },
    {
      id: 5,
      question: "Địa điểm du lịch mơ ước của đối phương?",
      options: ["Paris", "Tokyo", "New York", "Maldives", "Bali", "London"],
      category: "Du lịch"
    },
    {
      id: 6,
      question: "Thời gian trong ngày đối phương thích nhất?",
      options: ["Sáng sớm", "Buổi trưa", "Chiều tối", "Đêm khuya", "Nửa đêm", "Bình minh"],
      category: "Thói quen"
    },
    {
      id: 7,
      question: "Loại phim đối phương yêu thích nhất?",
      options: ["Hành động", "Lãng mạn", "Kinh dị", "Hài kịch", "Khoa học viễn tưởng", "Tài liệu"],
      category: "Giải trí"
    },
    {
      id: 8,
      question: "Đối phương sợ nhất điều gì?",
      options: ["Côn trùng", "Độ cao", "Bóng tối", "Đám đông", "Cô đơn", "Thất bại"],
      category: "Tâm lý"
    },
    {
      id: 9,
      question: "Thức uống yêu thích của đối phương?",
      options: ["Cà phê", "Trà", "Nước ngọt", "Bia", "Nước ép", "Nước lọc"],
      category: "Ẩm thực"
    },
    {
      id: 10,
      question: "Đối phương muốn có bao nhiêu con?",
      options: ["0", "1", "2", "3", "4", "Nhiều hơn 4"],
      category: "Tương lai"
    },
    {
      id: 11,
      question: "Vị trí ngủ yêu thích của đối phương?",
      options: ["Nằm ngửa", "Nằm nghiêng trái", "Nằm nghiêng phải", "Nằm sấp", "Cuộn tròn", "Duỗi thẳng"],
      category: "Thói quen"
    },
    {
      id: 12,
      question: "Điều đối phương ước muốn thay đổi về bản thân?",
      options: ["Ngoại hình", "Tính cách", "Công việc", "Sức khỏe", "Kỹ năng", "Không gì cả"],
      category: "Tâm lý"
    },
    {
      id: 13,
      question: "Thể loại nhạc đối phương thích nhất?",
      options: ["Pop", "Rock", "Ballad", "Rap", "Jazz", "Cổ điển"],
      category: "Âm nhạc"
    },
    {
      id: 14,
      question: "Đối phương thích mua sắm ở đâu nhất?",
      options: ["Trung tâm thương mại", "Chợ truyền thống", "Online", "Cửa hàng nhỏ", "Outlet", "Không thích shopping"],
      category: "Shopping"
    },
    {
      id: 15,
      question: "Điều đối phương tự hào nhất về bản thân?",
      options: ["Ngoại hình", "Tài năng", "Tính cách", "Thành tích", "Gia đình", "Bạn bè"],
      category: "Tâm lý"
    }
  ];

  const startGame = () => {
    if (player1Name && player2Name) {
      setGameState('playing');
      setCurrentQuestion(0);
      setCurrentPlayer(1);
      setAnswers({});
      setScore({ player1: 0, player2: 0 });
    }
  };

  const handleAnswerSelect = (answer) => {
    setSelectedAnswer(answer);
  };

  const submitAnswer = () => {
    if (!selectedAnswer) return;

    const questionId = questions[currentQuestion].id;
    const playerId = currentPlayer;
    
    setAnswers(prev => ({
      ...prev,
      [`${questionId}_${playerId}`]: selectedAnswer
    }));

    if (currentPlayer === 1) {
      // Switch to player 2 for the same question
      setCurrentPlayer(2);
      setSelectedAnswer(null);
    } else {
      // Both players answered, check if answers match
      const player1Answer = answers[`${questionId}_1`];
      const player2Answer = selectedAnswer;
      
      if (player1Answer === player2Answer) {
        setScore(prev => ({
          player1: prev.player1 + 1,
          player2: prev.player2 + 1
        }));
      }
      
      setShowResult(true);
      
      // Move to next question after 3 seconds
      setTimeout(() => {
        setShowResult(false);
        setSelectedAnswer(null);
        
        if (currentQuestion < questions.length - 1) {
          setCurrentQuestion(prev => prev + 1);
          setCurrentPlayer(1);
        } else {
          setGameState('results');
        }
      }, 3000);
    }
  };

  const resetGame = () => {
    setGameState('setup');
    setCurrentQuestion(0);
    setCurrentPlayer(1);
    setAnswers({});
    setSelectedAnswer(null);
    setShowResult(false);
    setScore({ player1: 0, player2: 0 });
  };

  const getCurrentPlayerName = () => {
    return currentPlayer === 1 ? player1Name : player2Name;
  };

  const getScorePercentage = () => {
    return Math.round((score.player1 / questions.length) * 100);
  };

  const getScoreMessage = () => {
    const percentage = getScorePercentage();
    if (percentage >= 80) return "Tuyệt vời! Hai bạn hiểu nhau rất sâu sắc! 💕";
    if (percentage >= 60) return "Khá tốt! Hai bạn cần tìm hiểu nhau nhiều hơn! 😊";
    if (percentage >= 40) return "Ổn đấy! Còn nhiều điều thú vị để khám phá! 🤔";
    return "Hai bạn cần dành thời gian hiểu nhau nhiều hơn! 💪";
  };

  if (showPrivacy) {
    return (
      <div className="min-h-screen p-4 flex flex-col">
        <motion.button
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          onClick={() => setShowPrivacy(false)}
          className="self-start mb-4 bg-white/20 hover:bg-white/30 text-white p-3 rounded-full transition-all"
        >
          <SafeIcon icon={FiArrowLeft} className="text-xl" />
        </motion.button>
        
        <div className="flex-1 flex items-center justify-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-2xl w-full bg-white/10 backdrop-blur-lg p-8 rounded-3xl"
          >
            <h1 className="text-3xl font-bold text-white text-center mb-6">
              Điều Khoản & Quyền Riêng Tư
            </h1>
            
            <div className="space-y-6 text-white">
              <div>
                <h2 className="text-xl font-bold mb-2">1. Giới Hạn Độ Tuổi:</h2>
                <p className="text-pink-200">
                  Ứng dụng này chỉ dành cho người từ 18 tuổi trở lên. Bằng việc sử dụng ứng dụng này, bạn xác nhận mình đã đủ tuổi theo quy định.
                </p>
              </div>
              
              <div>
                <h2 className="text-xl font-bold mb-2">2. Quyền Sở Hữu:</h2>
                <p className="text-pink-200">
                  Game này được tạo và sở hữu độc quyền bởi Lux Homestay. Mọi hình thức sao chép, phân phối lại mà không có sự cho phép đều bị nghiêm cấm.
                </p>
              </div>
              
              <div>
                <h2 className="text-xl font-bold mb-2">3. Nội Dung:</h2>
                <p className="text-pink-200">
                  Trò chơi có chứa nội dung người lớn và chỉ nên chơi trong không gian riêng tư. Người dùng tự chịu trách nhiệm về việc sử dụng trò chơi này.
                </p>
              </div>
              
              <div>
                <h2 className="text-xl font-bold mb-2">4. Quyền Riêng Tư:</h2>
                <p className="text-pink-200">
                  Chúng tôi không thu thập, lưu trữ hay chia sẻ bất kỳ thông tin cá nhân nào của người dùng. Trò chơi được chơi hoàn toàn ngoại tuyến.
                </p>
              </div>
              
              <div>
                <h2 className="text-xl font-bold mb-2">5. Miễn Trừ Trách Nhiệm:</h2>
                <p className="text-pink-200">
                  Lux Homestay không chịu trách nhiệm về bất kỳ hậu quả nào phát sinh từ việc sử dụng trò chơi này. Người dùng tự chịu trách nhiệm về quyết định và hành động của mình.
                </p>
              </div>
              
              <div className="pt-4 border-t border-white/20">
                <p className="text-center text-pink-200">
                  © 2023 Lux Homestay. Bảo lưu mọi quyền.
                </p>
              </div>
              
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => setShowPrivacy(false)}
                className="w-full mt-4 bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 text-white font-bold py-4 px-6 rounded-2xl shadow-lg transition-all duration-300"
              >
                Tôi Đã Hiểu & Đồng Ý
              </motion.button>
            </div>
          </motion.div>
        </div>
      </div>
    );
  }

  if (gameState === 'setup') {
    return (
      <div className="min-h-screen p-4 flex flex-col">
        <motion.button
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          onClick={() => navigate('/')}
          className="self-start mb-4 bg-white/20 hover:bg-white/30 text-white p-3 rounded-full transition-all"
        >
          <SafeIcon icon={FiArrowLeft} className="text-xl" />
        </motion.button>

        <div className="flex-1 flex items-center justify-center">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-md w-full bg-white/10 backdrop-blur-lg p-8 rounded-3xl"
          >
            <h1 className="text-4xl font-bold text-white text-center mb-6">
              💕 Couple Quiz 💕
            </h1>

            <div className="space-y-6">
              <div>
                <label className="block text-pink-200 text-sm font-bold mb-2">
                  Tên Người Chơi 1:
                </label>
                <input
                  type="text"
                  value={player1Name}
                  onChange={(e) => setPlayer1Name(e.target.value)}
                  className="w-full p-3 rounded-xl bg-white/20 text-white placeholder-pink-200 border border-pink-300/30 focus:border-pink-400 focus:outline-none"
                  placeholder="Nhập tên..."
                />
              </div>

              <div>
                <label className="block text-pink-200 text-sm font-bold mb-2">
                  Tên Người Chơi 2:
                </label>
                <input
                  type="text"
                  value={player2Name}
                  onChange={(e) => setPlayer2Name(e.target.value)}
                  className="w-full p-3 rounded-xl bg-white/20 text-white placeholder-pink-200 border border-pink-300/30 focus:border-pink-400 focus:outline-none"
                  placeholder="Nhập tên..."
                />
              </div>

              <div className="bg-pink-500/20 p-4 rounded-xl">
                <h3 className="text-white font-medium mb-2 text-center">Hướng Dẫn Chơi</h3>
                <p className="text-pink-200 text-sm">
                  Trả lời các câu hỏi về đối phương của mình. Mỗi câu hỏi, cả hai người sẽ lần lượt trả lời. 
                  Nếu cả hai có cùng đáp án, bạn sẽ được điểm! Hãy xem hai bạn hiểu nhau đến mức nào!
                </p>
              </div>

              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={startGame}
                disabled={!player1Name || !player2Name}
                className="w-full bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 disabled:from-gray-400 disabled:to-gray-500 disabled:cursor-not-allowed text-white font-bold py-4 px-8 rounded-2xl shadow-lg transition-all duration-300"
              >
                Bắt Đầu Quiz! 💕
              </motion.button>

              <div className="flex items-center justify-between">
                <button
                  onClick={() => setShowPrivacy(true)}
                  className="text-pink-200 text-xs underline flex items-center"
                >
                  <SafeIcon icon={FiInfo} className="mr-1 text-xs" />
                  Điều khoản & Quyền riêng tư
                </button>
                <p className="text-pink-200 text-xs">
                  © 2023 Lux Homestay
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    );
  }

  if (gameState === 'results') {
    return (
      <div className="min-h-screen p-4 flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          className="max-w-md w-full bg-white/10 backdrop-blur-lg p-8 rounded-3xl text-center"
        >
          <h1 className="text-4xl font-bold text-white mb-6">
            🎉 Kết Quả Quiz! 🎉
          </h1>

          <div className="bg-gradient-to-r from-yellow-400 to-orange-500 p-6 rounded-2xl mb-6">
            <SafeIcon icon={FiAward} className="text-4xl text-white mb-2" />
            <h2 className="text-2xl font-bold text-white mb-2">
              {score.player1}/{questions.length} câu đúng
            </h2>
            <p className="text-white/90">
              {getScorePercentage()}% độ hiểu biết
            </p>
          </div>

          <div className="bg-pink-500/20 p-4 rounded-xl mb-6">
            <p className="text-pink-200 text-lg">
              {getScoreMessage()}
            </p>
          </div>

          <div className="space-y-4">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={resetGame}
              className="w-full bg-gradient-to-r from-green-500 to-blue-500 hover:from-green-600 hover:to-blue-600 text-white font-bold py-3 px-6 rounded-xl shadow-lg transition-all duration-300 flex items-center justify-center gap-2"
            >
              <SafeIcon icon={FiRefreshCw} />
              Chơi Lại
            </motion.button>

            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate('/')}
              className="w-full bg-white/20 hover:bg-white/30 text-white font-bold py-3 px-6 rounded-xl transition-all duration-300"
            >
              Về Menu Chính
            </motion.button>
          </div>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-4 flex flex-col">
      <motion.button
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        onClick={() => navigate('/')}
        className="self-start mb-4 bg-white/20 hover:bg-white/30 text-white p-3 rounded-full transition-all"
      >
        <SafeIcon icon={FiArrowLeft} className="text-xl" />
      </motion.button>

      <div className="flex-1 flex flex-col items-center justify-center">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-8"
        >
          <div className="bg-gradient-to-r from-purple-500 to-pink-500 p-4 rounded-2xl mb-4">
            <h1 className="text-2xl font-bold text-white">
              Câu {currentQuestion + 1}/{questions.length}
            </h1>
            <p className="text-pink-200">
              Lượt của: <span className="font-bold">{getCurrentPlayerName()}</span>
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-lg p-4 rounded-xl">
            <span className="text-pink-300 text-sm">
              {questions[currentQuestion].category}
            </span>
          </div>
        </motion.div>

        <div className="max-w-md w-full">
          <AnimatePresence mode="wait">
            {!showResult ? (
              <motion.div
                key={`question-${currentQuestion}-${currentPlayer}`}
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -100 }}
                className="bg-white/10 backdrop-blur-lg p-8 rounded-3xl"
              >
                <h2 className="text-xl font-bold text-white mb-6 text-center">
                  {questions[currentQuestion].question}
                </h2>

                <div className="grid grid-cols-2 gap-3 mb-6">
                  {questions[currentQuestion].options.map((option, index) => (
                    <motion.button
                      key={index}
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={() => handleAnswerSelect(option)}
                      className={`p-3 rounded-xl text-sm font-medium transition-all ${
                        selectedAnswer === option
                          ? 'bg-pink-500 text-white'
                          : 'bg-white/10 text-white/80 hover:bg-white/20'
                      }`}
                    >
                      {option}
                    </motion.button>
                  ))}
                </div>

                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={submitAnswer}
                  disabled={!selectedAnswer}
                  className="w-full bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 disabled:from-gray-400 disabled:to-gray-500 disabled:cursor-not-allowed text-white font-bold py-3 px-6 rounded-xl shadow-lg transition-all duration-300"
                >
                  Xác Nhận Đáp Án
                </motion.button>
              </motion.div>
            ) : (
              <motion.div
                key={`result-${currentQuestion}`}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                className="bg-white/10 backdrop-blur-lg p-8 rounded-3xl text-center"
              >
                <div className={`text-6xl mb-4 ${
                  answers[`${questions[currentQuestion].id}_1`] === selectedAnswer ? '🎉' : '😢'
                }`}>
                  {answers[`${questions[currentQuestion].id}_1`] === selectedAnswer ? (
                    <SafeIcon icon={FiCheck} className="text-green-400" />
                  ) : (
                    <SafeIcon icon={FiX} className="text-red-400" />
                  )}
                </div>

                <h3 className="text-2xl font-bold text-white mb-4">
                  {answers[`${questions[currentQuestion].id}_1`] === selectedAnswer ? 
                    'Cùng đáp án! 💕' : 'Khác đáp án! 😅'}
                </h3>

                <div className="space-y-2 text-pink-200">
                  <p>{player1Name}: {answers[`${questions[currentQuestion].id}_1`]}</p>
                  <p>{player2Name}: {selectedAnswer}</p>
                </div>

                <div className="mt-4 text-white">
                  <p>Điểm hiện tại: {score.player1}/{currentQuestion + 1}</p>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default CoupleQuizGame;